import dayjs from 'dayjs';
import { getStatusLabel } from '../positions/positionStatus';

// Ferias (PLAN_FERIAS): estado de una vacante en la página pública de la feria.
// Lo calcula el backend con el mismo filtro que la web de empleos.
export const STATE_COLORS = {
  shown: 'success',
  not_active: 'default',
  hidden: 'warning',
  limit_reached: 'warning',
  deleted: 'error',
};

// Estados con su propio texto en "No se muestra: …" (la vacante, en femenino)
const NOT_ACTIVE_STATUSES = ['draft', 'suspended', 'closed', 'cancelled'];

/** "Se muestra" o "No se muestra: <motivo>" */
export const getPublicStateLabel = (item, t) => {
  const state = STATE_COLORS[item?.publicState] ? item.publicState : 'shown';
  if (state === 'not_active') {
    const status = NOT_ACTIVE_STATUSES.includes(item.status)
      ? t(`ats.fairs.state.statuses.${item.status}`)
      : getStatusLabel(item.status, t).toLowerCase();
    return t('ats.fairs.state.not_active', { status });
  }
  return t(`ats.fairs.state.${state}`);
};

/**
 * Estado provisional de una vacante recién agregada desde el selector, antes
 * de guardar (el cupo de las masivas lo confirma el backend al guardar).
 */
export const provisionalState = (item) => {
  if (item.status !== 'active') return 'not_active';
  if (!item.visibleInPortal) return 'hidden';
  return 'shown';
};

/** Fecha ISO → DD/MM/AAAA (convención del repo) */
export const formatDate = (iso) => (iso && dayjs(iso).isValid() ? dayjs(iso).format('DD/MM/YYYY') : '—');

/** Nombre que reconoce el consultor: el interno y, si no hay, el público */
export const positionTitle = (item) => item?.internalName || item?.name || '';
